<template>
  <v-dialog fullscreen :readonly="readonly" v-model="show">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click.native="close">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Update Company</v-toolbar-title>
      </v-toolbar>
      <v-card-text id="company-settings">
        <v-container
          v-if="companySettingsLoading"
          fill-height
          style="min-height: 130px"
        >
          <v-layout row wrap align-center py-4>
            <v-flex class="text-xs-center">
              <v-progress-circular
                indeterminate
                v-bind:size="50"
                color="primary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
        <form
          v-if="!companySettingsLoading"
          @submit.prevent="updateCompanySettings"
        >
          <input
            type="file"
            accept=".jpeg, .png, .jpg"
            @change="setTempCompanyLogo"
            ref="companylogo"
            style="display: none"
          />
          <v-container
            class="grid-list-md"
            style="max-width: none; padding: 20px 41px 0px"
          >
            <v-layout row wrap>
              <v-flex md3>
                <v-layout row wrap class="pl-3 pt-3">
                  <v-tooltip bottom>
                    <template slot="activator">
                      <div class="profile-pic round">
                        <img
                          v-if="!companySettingsForm.companylogo"
                          :src="
                            tempCompanyLogo || '/static/images/yourlogo.png'
                          "
                          :alt="companySettingsForm.companylegalname"
                        />
                        <img
                          v-if="companySettingsForm.companylogo"
                          :src="
                            tempCompanyLogo || companySettingsForm.companylogo
                          "
                          :alt="companySettingsForm.companylegalname"
                        />
                        <v-layout
                          justify-center
                          row
                          align-center
                          @click="pickFile('companylogo')"
                          class="profile-upload-overlay"
                          :class="{ disabled: readonly }"
                        >
                          <div>
                            <v-icon dark>mdi-camera</v-icon><br />
                            <span>Upload image</span>
                          </div>
                        </v-layout>
                      </div>
                    </template>
                    <span v-if="!readonly">200px * 200px Recommended size</span>
                    <span v-else>View only</span>
                  </v-tooltip>
                </v-layout>
              </v-flex>
              <v-flex md9>
                <v-layout row wrap>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Company Name"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.companylegalname"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Address Line 1"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.addressline1"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Address Line 2"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.addressline2"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="City"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.city"
                      auto-grow
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Latitude"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.latitude"
                      auto-grow
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Longitude"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.longitude"
                      auto-grow
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="County"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.county"
                      auto-grow
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Zip"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.zip"
                      auto-grow
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <!-- <v-select v-bind:items="['AK','AL','AR','AZ','CA','CO','CT','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY']"
                          class="pr-2 mt-0" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.state"  label="State:" :disabled=""></v-select> -->
                    <v-select
                      v-bind:items="[
                        'AK',
                        'AL',
                        'AR',
                        'AZ',
                        'CA',
                        'CO',
                        'CT',
                        'DE',
                        'FL',
                        'GA',
                        'HI',
                        'IA',
                        'ID',
                        'IL',
                        'IN',
                        'KS',
                        'KY',
                        'LA',
                        'MA',
                        'MD',
                        'ME',
                        'MI',
                        'MN',
                        'MO',
                        'MS',
                        'MT',
                        'NC',
                        'ND',
                        'NE',
                        'NH',
                        'NJ',
                        'NM',
                        'NV',
                        'NY',
                        'OH',
                        'OK',
                        'OR',
                        'PA',
                        'RI',
                        'SC',
                        'SD',
                        'TN',
                        'TX',
                        'UT',
                        'VA',
                        'VT',
                        'WA',
                        'WI',
                        'WV',
                        'WY',
                      ]"
                      class="pr-2 mt-0"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.state"
                      label="State:"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Company Website"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.businesswebsite"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Public Contact Phone Number"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.phonenumber"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-text-field
                      label="Public Contact Email"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.email"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md4 class="text-align-left">
                    <v-select
                      :items="primaryIndustry"
                      v-if="
                        companySettingsForm.companyprimaryindustry !== 'Other'
                      "
                      label="Primary Industry"
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.companyprimaryindustry"
                    ></v-select>
                    <v-text-field
                      label="Enter Primary Industry"
                      class="pr-2"
                      no-data-text="Type to add data"
                      v-if="
                        companySettingsForm.companyprimaryindustry === 'Other'
                      "
                      :disabled="readonly"
                      :readonly="readonly"
                      v-model="companySettingsForm.companyprimaryindustry"
                      placeholder="Primary Industry"
                    >
                    </v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 md4 sm6 class="text-align-left">
                    <v-select v-bind:items="['AK','AL','AR','AZ','CA','CO','CT','DE','FL','GA','HI','IA','ID','IL','IN','KS','KY','LA','MA','MD','ME','MI','MN','MO','MS','MT','NC','ND','NE','NH','NJ','NM','NV','NY','OH','OK','OR','PA','RI','SC','SD','TN','TX','UT','VA','VT','WA','WI','WV','WY']"
                      class="pr-2 mt-0" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.companyheadquarterstate" label="Company Headquarter State:"></v-select>
                  </v-flex> -->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container
            class="grid-list-md"
            style="max-width: none; padding: 0px 41px; padding-bottom: 20px"
          >
            <v-layout row wrap class="pt-0">
              <v-flex xs12 md12 class="text-align-left">
                <v-text-field
                  multi-line
                  label="Company Description"
                  maxlength="250"
                  :counter="250"
                  :rules="[(val) => val.length <= 250 || 'Max 250 characters']"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.companydescription"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-text-field
                  label="DUNS Number"
                  :rules="[
                    () =>
                      companySettingsForm.dunsnumber.length > 9
                        ? 'You can only add 9 characters'
                        : true,
                    () =>
                      companySettingsForm.dunsnumber.length < 9
                        ? 'Must be of 9 digits'
                        : true,
                  ]"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.dunsnumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-text-field
                  label="Cage Code"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.cagecode"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  v-bind:items="['Yes', 'No']"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.fedcontractor"
                  label="Federal Contractor?"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-text-field
                  label="Federal Contractor Type"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.fedcontractortype"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  :items="naicscodes"
                  label="Primary NAICS Code"
                  no-data-text="Type to add data"
                  cache-items
                  :search-input.sync="naicsSearch"
                  autocomplete
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.primarynaicscode"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  :items="additionalNaicscodes"
                  no-data-text="Type to add data"
                  :search-input.sync="additionalNaicsSearch"
                  autocomplete
                  :rules="[
                    () =>
                      companySettingsForm.additionalnaicscodes.length > 5
                        ? 'You can only add five codes'
                        : true,
                  ]"
                  multiple
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.additionalnaicscodes"
                  label="Additional NAICS Codes"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  :items="psccodes"
                  label="Primary PSC Code"
                  cache-items
                  no-data-text="Type to add data"
                  :search-input.sync="pscSearch"
                  autocomplete
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.primarypsccode"
                ></v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  :items="additionalPsccodes"
                  no-data-text="Type to add data"
                  :search-input.sync="additionalPscSearch"
                  autocomplete
                  cache-items
                  multiple
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.additionalpsccodes"
                  label="Additional PSC Codes"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  v-bind:items="certifications"
                  class="mt-0"
                  multiple
                  cache-items
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.companycertifications"
                  label="Company Certifications"
                />
              </v-flex>
              <v-flex xs12 md3 class="text-align-left">
                <v-select
                  :items="[
                    'None',
                    'TOP SECRET',
                    'SECRET',
                    'CONFIDENTIAL',
                    'FACILITY',
                    'Q Clearance',
                    'L Clearance',
                  ]"
                  label="Security Clearance"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.securityclearance"
                ></v-select>
              </v-flex>
              <!-- <v-flex xs12 md4 class="text-align-left">
                <v-text-field label="GSA Schedule Number" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.gsaschedulenumber"></v-text-field>
              </v-flex> -->
              <v-flex xs12 md12 class="text-align-left">
                <v-text-field
                  multi-line
                  label="Specialties"
                  maxlength="250"
                  :height="80"
                  :counter="250"
                  :rules="[(val) => val.length <= 250 || 'Max 250 characters']"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.specialties"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md12 class="text-align-left">
                <v-text-field
                  multi-line
                  label="Capabilities"
                  maxlength="250"
                  :height="80"
                  :counter="250"
                  :rules="[(val) => val.length <= 250 || 'Max 250 characters']"
                  :disabled="readonly"
                  :readonly="readonly"
                  v-model="companySettingsForm.capabilities"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 md12 class="text-align-left">
                <v-text-field multi-line label="Specialties Exported" maxlength="250" :counter="250" :rules="[(val) => val.length <= 250 || 'Max 250 characters']"
                  :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.specialtiesexported"></v-text-field>
              </v-flex> -->
              <!-- <v-flex xs12 md4>
                <v-checkbox label="Small Business" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.smallbusiness"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Certified 8a" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.certified8a"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Exporter" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.exporter"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Woman Owned" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.womanowned"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Woman Owned Small Business" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.womanownedsmallbusiness"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="International Trade" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.internationaltrade"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Veteran Owned" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.veteranowned"></v-checkbox>
              </v-flex>
              <v-flex xs12 md8>
                <v-checkbox label="Service Related Disabled Veteran Owned" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.servicerelateddisabledveteranowned"></v-checkbox>
              </v-flex>
              <v-flex xs12 md4>
                <v-checkbox label="Minority Owned" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.minorityowned"></v-checkbox>
              </v-flex>
              <v-flex xs12 md8>
                <v-checkbox label="Hubzone" :disabled="readonly" :readonly="readonly" v-model="companySettingsForm.hubzone"></v-checkbox>
              </v-flex> -->
              <!-- <v-flex xs12 md4 class="text-align-left">
                <v-menu
                  ref="menu1"
                  :close-on-content-click="false"
                  v-model="pickDateMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  :disabled="readonly"
                  max-width="290px"
                  min-width="290px"
                  style="margin-left:0px;float:none;"
                >
                  <v-text-field
                    slot="activator"
                    v-model="companySettingsForm.profilesubmissiondate"
                    label="Profile Submission Date"
                    :disabled="readonly"
                    readonly
                  ></v-text-field>
                  <v-date-picker :readonly="readonly" v-model="companySettingsForm.profilesubmissiondate" no-title @input="pickDateMenu = false"></v-date-picker>
                </v-menu>
              </v-flex> -->
              <v-flex xs12 text-align-left>
                <input
                  style="display: none"
                  accept=".docx,.doc,.pdf"
                  type="file"
                  @change="setTempCompanyStatement"
                  ref="companystatement"
                />
                <v-btn
                  v-if="companySettingsForm.capabilitiesstatement.length"
                  style="margin: 0px 10px 0px 0px; width: auto; height: auto"
                  :href="companySettingsForm.capabilitiesstatement"
                  target="_blank"
                  icon
                >
                  <img
                    src="/static/img/my-cap-stat.png"
                    style="width: 100px; height: 100px"
                  />
                </v-btn>
                <v-btn
                  :disabled="readonly"
                  label="Upload"
                  style="margin: 0px 10px 0px 0px; width: auto; height: auto"
                  @click.prevent="pickFile('companystatement')"
                  icon
                >
                  <img
                    src="/static/img/upload-icon.png"
                    style="width: 100px; height: 100px"
                  />
                </v-btn>
                {{ statementFileName }}
              </v-flex>
              <v-flex xs12 md12 pa-4>
                <v-layout>
                  <v-btn
                    type="submit"
                    style="margin: 0 auto"
                    dark
                    class="primary"
                    :disabled="readonly"
                    :loading="loading"
                  >
                    Update
                    <span slot="loader" class="custom-loader">
                      <v-icon light>cached</v-icon>
                    </span>
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  props: ["readonly", "id", "show", "refreshTable"],
  data() {
    return {
      pickDateMenu: false,
      tempCompanyLogo: null,
      tempCompanyLogoFile: null,
      statementFileName: null,
      companySettingsLoading: false,
      naicscodes: [],
      psccodes: [],
      additionalNaicscodes: [],
      additionalPsccodes: [],
      updatedCompanyFields: [],
      naicsSearch: "",
      pscSearch: "",
      additionalNaicsSearch: "",
      additionalPscSearch: "",
      loading: false,
      companySettingsForm: {
        companylegalname: "",
        addressline1: "",
        addressline2: "",
        city: "",
        county: "",
        zip: "",
        state: "GA",
        businesswebsite: "",
        phonenumber: "",
        email: "",
        companydescription: "",
        dunsnumber: "",
        cagecode: "",
        companycertifications: [],
        fedcontractor: "",
        fedcontractortype: "",
        companyprimaryindustry: "",
        primarypsccode: "",
        securityclearance: "",
        smallbusiness: false,
        womanowned: false,
        additionalpsccodes: [],
        minorityowned: false,
        certified8a: false,
        additionalnaicscodes: [],
        veteranowned: false,
        primarynaicscode: [],
        specialties: "",
        capabilities: "",
        companylogo: "",
        capabilitiesstatement: "",
      },
      certifications: [
        "Total Small Business",
        "Competitive 8(a)",
        "Veteran-Owned Small Business",
        "Service-Disabled Veteran-Owned Small Business",
        "Woman Owned Small Business",
        "Economically Disadvantaged Woman Owned Small Business",
        "Indian Small Business Economic Enterprises",
        "Indian Economic Enterprises",
        "Emerging Small Business",
        "Partial Small Business",
        "Very Small Business",
        "Partial HBCU / MI",
        "Total HBCU / MI",
      ],
      primaryIndustry: [
        "Aerospace",
        "Agribusiness",
        "Construction",
        "Defense",
        "Finance",
        "Information Technology",
        "Logistics",
        "Manufacturing",
        "R&D",
        "Retail",
        "Service",
        "Surplus Dealer",
        "Telecommunications",
        "Wholesale",
        "Other",
      ],
    };
  },
  computed: {
    company() {
      const details = this.$store.getters.getCompanyDetails;
      // if (details.id) {
      //   this.getCompanySetting(details.id)
      // }
      return details;
    },
  },
  watch: {
    show(val) {
      if (val) {
        return this.getCompanySetting(this.id);
      }
    },
    naicsSearch(val) {
      val && this.queryNaicsCodes(val);
    },
    additionalNaicsSearch(val) {
      val && this.queryAdditionalNaicsCodes(val);
    },
    additionalPscSearch(val) {
      val && this.queryAdditionalPscCodes(val);
    },
    pscSearch(val) {
      val && this.queryPscCodes(val);
    },
    companySettingsForm: {
      handler(newVal) {
        if (this.watchCompanySettingsForm) {
          this.updatedCompanyFields = this._.union(
            this._.cloneDeep(this.updatedCompanyFields),
            [
              "companycertifications",
              "additionalpsccodes",
              "additionalnaicscodes",
            ],
            this.getUpdatedCompanyFields(this.oldCompanySettings, newVal)
          );
          this.oldCompanySettings = this._.cloneDeep(newVal);
          return;
        }
        this.watchCompanySettingsForm = true;
        this.oldCompanySettings = this._.cloneDeep(newVal);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (typeof date === "number") {
        return moment(new Date(date)).format("YYYY-MM-DD");
        // eslint-disable-next-line valid-typeof
      } else if (typeof date === "str" && Number(date)) {
        return moment(new Date(Number(date))).format("YYYY-MM-DD");
      } else {
        return date;
      }
    },
    close() {
      this.$emit("closeModal", "companyModalDialog");
    },
    async updateCompanySettings() {
      const companyId = this.id;
      const api = `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2`;
      let updates = {
        _id: companyId,
      };
      for (var i = 0; i < this.updatedCompanyFields.length; i++) {
        if (
          this.updatedCompanyFields[i] === "companycertifications" ||
          this.updatedCompanyFields[i] === "additionalnaicscodes" ||
          this.updatedCompanyFields[i] === "additionalpsccodes"
        ) {
          updates[this.updatedCompanyFields[i]] =
            this.companySettingsForm[this.updatedCompanyFields[i]].join(",");
        } else {
          updates[this.updatedCompanyFields[i]] =
            this.companySettingsForm[this.updatedCompanyFields[i]];
        }
      }
      this.$store.dispatch("triggerSnackbar", {
        text: "Updating company settings",
        active: true,
      });
      const { addressline1, addressline2, city, state, zip } =
        this.companySettingsForm;
      const streetaddress = [addressline1, addressline2, city, state, zip]
        .filter((v) => v)
        .join(", ");
      updates.streetaddress = streetaddress;

      if (updates.profilesubmissiondate) {
        updates.profilesubmissiondate = new Date(
          updates.profilesubmissiondate
        ).getTime();
      }
      if (this.tempCompanyLogoFile) {
        var url = await this.uploadLogo(this.id);
        updates.companylogo = url;
      }
      if (this.tempCompanyStatementFile) {
        var url = await this.uploadStatement(this.id);
        updates.capabilitiesstatement = url;
      }
      if (Object.keys(updates).length) {
        return axios.post(api, updates).then((res) => {
          this.$firebase
            .database()
            .ref(`/companies/${companyId}`)
            .update(
              this._.pick(updates, [
                "companylegalname",
                "companylogo",
                "capabilitiesstatement",
                "profilesubmitted",
                "profilesubmissiondate",
                "submitby",
                "submitdate",
              ])
            );
          this.$store.dispatch("triggerSnackbar", {
            text: "Updated successfully!",
            active: true,
          });
          this.updatedCompanyFields = [
            "companycertifications",
            "additionalpsccodes",
            "additionalnaicscodes",
          ];
          this.getCompanySetting(companyId);
          this.refreshTable(companyId);
        });
      } else {
        this.$store.dispatch("triggerSnackbar", {
          text: "You haven't made any updates yet.",
          active: true,
        });
      }
    },
    pickFile(key) {
      this.$refs[key].click();
    },
    setTempCompanyLogo() {
      const self = this;
      const reader = new window.FileReader();
      const blob = this.$refs.companylogo.files[0];
      this.tempCompanyLogoFile = blob;
      reader.onload = (e) => {
        self.tempCompanyLogo = reader.result;
      };
      reader.readAsDataURL(blob);
    },
    setTempCompanyStatement() {
      const blob = this.$refs.companystatement.files;
      this.statementFileName = blob[0].name;
      this.tempCompanyStatementFile = blob;
    },
    getCompanySetting(companyId) {
      const self = this;
      this.companySettingsLoading = true;
      const api = `https://fed-exchange-api.herokuapp.com/api/v2.0/exchange-community-v2/${companyId}`;
      return axios.get(api).then((res) => {
        if (!res.data) return;
        self.companySettingsForm = Object.assign(res.data, {
          profilesubmissiondate: this.formatDate(
            res.data.profilesubmissiondate
          ),
          companycertifications: !Array.isArray(res.data?.companycertifications)
            ? res.data?.companycertifications?.split(",") || []
            : res.data.companycertifications || [],
          additionalnaicscodes:
            res.data.additionalnaicscodes &&
            !Array.isArray(res.data.additionalnaicscodes)
              ? res.data.additionalnaicscodes
                  .split(",")
                  .filter((val) => val.length)
                  .reduce((i, val) => {
                    i.push(val.replace(" ", ""));
                    return i;
                  }, [])
              : res.data.additionalnaicscodes || [],
          additionalpsccodes:
            res.data?.additionalpsccodes &&
            !Array.isArray(res.data?.additionalpsccodes)
              ? res.data?.additionalpsccodes
                  .split(",")
                  .filter((val) => val.length)
                  .reduce((i, val) => {
                    i.push(val.replace(" ", ""));
                    return i;
                  }, [])
              : res.data.additionalpsccodes || [],
        });
        self.queryPscCodes("1");
        self.queryNaicsCodes("1");
        self.queryAdditionalPscCodes("1");
        self.queryAdditionalNaicsCodes("1").then(() => {
          self.companySettingsLoading = false;
        });
      });
    },
    getUpdatedCompanyFields(obj1, obj2) {
      var keys = this._.union(_.keys(obj1), this._.keys(obj2));
      return this._.filter(keys, (key) => {
        if (
          key === "companycertifications" ||
          key === "additionalnaicscodes" ||
          key === "additionalpsccodes"
        ) {
          return this._.differenceWith(obj2[key], obj1[key]).length;
        }
        return obj1[key] !== obj2[key];
      });
    },
    queryNaicsCodes(val) {
      const self = this;
      return axios
        .get(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=naics&search=${val}`
        )
        .then((res) => {
          // eslint-disable-next-line
          let i;
          for (i = 0; i < res.data.count; i++) {
            self.naicscodes.push(res.data.data[i].naicscode);
          }
        });
    },
    queryAdditionalNaicsCodes(val) {
      const self = this;
      return axios
        .get(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=naics&search=${val}`
        )
        .then((res) => {
          // eslint-disable-next-line
          let i;
          for (i = 0; i < res.data.count; i++) {
            self.additionalNaicscodes.push(res.data.data[i].naicscode);
          }
        });
    },
    queryPscCodes(val) {
      const self = this;
      return axios
        .get(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=psc&search=${val}`
        )
        .then((res) => {
          let i;
          for (i = 0; i < res.data.count; i++) {
            self.psccodes.push(res.data.data[i].psccode);
          }
        });
    },
    queryAdditionalPscCodes(val) {
      const self = this;
      return axios
        .get(
          `https://fed-exchange-api.herokuapp.com/api/v2.0/codes?type=psc&search=${val}`
        )
        .then((res) => {
          let i;
          for (i = 0; i < res.data.count; i++) {
            self.additionalPsccodes.push(res.data.data[i].psccode);
          }
        });
    },
    async uploadLogo(company) {
      var storageRef = this.$firebase.storage().ref();
      var logoRef = storageRef.child(`companies/${company}/logo.jpg`);
      try {
        await logoRef.put(this.tempCompanyLogoFile);
      } catch (error) {
        let snackbar = {
          active: true,
          text: error.message,
        };
        this.$store.dispatch("triggerSnackbar", snackbar);
        setTimeout(() => {
          let snackbar = {
            active: false,
            text: "",
          };

          this.$store.dispatch("triggerSnackbar", snackbar);
        }, 2000);
        return null;
      }
      try {
        var logoUrl = await storageRef
          .child(`companies/${company}/logo.jpg`)
          .getDownloadURL();
        return logoUrl;
      } catch (error) {
        let snackbar = {
          active: true,
          text: "An error occurred while updating the settings.Please try again later.",
        };
        this.$store.dispatch("triggerSnackbar", snackbar);
        setTimeout(() => {
          let snackbar = {
            active: false,
            text: "",
          };

          this.$store.dispatch("triggerSnackbar", snackbar);
        }, 3000);
        return null;
      }
    },
    async uploadStatement(company) {
      var storageRef = this.$firebase.storage().ref();
      var ext = ".pdf";
      var type = this.tempCompanyStatementFile[0].type
        .split("/")[1]
        .toLowerCase();
      if (type === "msword") {
        ext = ".doc";
      }
      var statementRef = storageRef.child(
        `companies/${company}/statement${ext}`
      );
      try {
        await statementRef.put(this.tempCompanyStatementFile[0]);
      } catch (error) {
        let snackbar = {
          active: true,
          text: "An error occurred while updating the settings.Please try again later.",
        };
        this.$store.dispatch("triggerSnackbar", snackbar);
        setTimeout(() => {
          let snackbar = {
            active: false,
            text: "",
          };

          this.$store.dispatch("triggerSnackbar", snackbar);
        }, 3000);
        return null;
      }
      try {
        var statementUrl = await storageRef
          .child(`companies/${company}/statement${ext}`)
          .getDownloadURL();
        return statementUrl;
      } catch (error) {
        let snackbar = {
          active: true,
          text: error.message,
        };
        this.$store.dispatch("triggerSnackbar", snackbar);
        setTimeout(() => {
          let snackbar = {
            active: false,
            text: "",
          };

          this.$store.dispatch("triggerSnackbar", snackbar);
        }, 2000);
        return null;
      }
    },
  },
};
</script>

<style>
.profile_tabs .tabs__bar {
  background-color: rgb(87, 113, 148);
}
.profile_tabs .tabs__bar .tabs__div {
  color: #fff;
}
.profile-pic.round {
  position: relative;
  border-radius: 100%;
  height: 200px;
  border: 2px solid rgba(74, 74, 74, 1);
}
.profile-pic.round > .profile-upload-overlay {
  width: 200px;
  cursor: pointer;
  display: none;
  border-radius: 100%;
  height: 200px;
  position: absolute;
  top: 0;
  background: rgba(62, 58, 58, 0.9);
}
.profile-upload-overlay div {
  margin-right: auto;
  margin-left: auto;
  width: 90px;
  text-align: center;
  margin-top: 80px;
  color: #fff;
}
.profile-pic.round:hover > .profile-upload-overlay {
  display: block;
}
.profile-pic.round:hover > .profile-upload-overlay.disabled {
  display: none;
}
.profile-pic.round img {
  border-radius: 100%;
  width: 200px;
  height: 200px;
}
#company-settings .input-group--select {
  margin-top: 0px !important;
}
#company-settings .input-group--text-field.input-group--multi-line textarea {
  height: 67px !important;
}
</style>



// WEBPACK FOOTER //
// CompanyModal.vue?77941a4b